import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './manageAccount.scss';
import DeactivateAccountPopup from './deactivateAccountPopup';

class ManageAccount extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            showDeactivatePopup: false, isMultiAccountView: false, programEnrollmentDetails: '', showDeactivatePopupError: false,
        };
        this.strings = getLocalizedStrings('ManageAccount');
        this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
        this.userGroups = app.appUtil.getAppConstants().USER_GROUPS;
        this.userType = this.props.userType;
        this.initialPositionValue = window.getComputedStyle(document.body).position;
    }

    componentWillUnmount() {
        app.appService.removeSessionStorageItem('customerPreferenceData');
    }
    /* Sonar Cube fix
    Done by : meesala
    Date : 23-01-2023
    */
    getProgramEnrollDetails = (webBPNum)=>{
        app.profileSettingsService.getProgramEnrollmentDetails(webBPNum).then((response) => {
            if(!response.errorCode){
                if((response.programsEnrolled) && (response.programsEnrolled.length > 0)){
                    this.setState({ showDeactivatePopup: true, showDeactivatePopupError: false, isMultiAccountView: false, programEnrollmentDetails: response.programsEnrolled});
                }else{
                    this.setState({ showDeactivatePopup: true, showDeactivatePopupError: false, isMultiAccountView: true });
                }      
            }else{
                this.setState({ showDeactivatePopup: false, showDeactivatePopupError: true });
            }
        }, (error) => { 
            this.setState({ showDeactivatePopup: false, showDeactivatePopupError: true });
        });
    }
    openDeactivatePopupHandler = () => {
        if((this.userType === this.userGroups.THIRDPARTY) || (this.userType === this.userGroups.BENCHMARK) || ((this.userType === this.userGroups.WEB) && (!this.props.bPNumberFound))){
            this.setState({ showDeactivatePopup: true, showDeactivatePopupError: false, isMultiAccountView: true });
        }else{
            let customerData = app.appService.getSessionstorage('customerPreferenceData');
            if((!_.isEmpty(customerData)) && (!_.isEmpty(customerData.contractAccountCount)) && (!_.isEmpty(customerData.contractCount))){
                    let webBPNum = '';
                    if((this.userType === this.userGroups.WEB) && (!_.isEmpty(this.props.bpNumber))){
                        webBPNum = this.props.bpNumber;
                        this.setState({ webBPNumber: webBPNum });
                    }
                    this.getProgramEnrollDetails(webBPNum);
            }else if((_.isEmpty(customerData)) && (!this.props.bPNumberFound) && (this.userType === this.userGroups.MYACCOUNT)){
                this.setState({ showDeactivatePopup: true, showDeactivatePopupError: false });    
            }else{
                this.setState({ showDeactivatePopup: false, showDeactivatePopupError: true });
            }
        }     
    }

    closeDeactivatePopupHandler = () => {
        this.setState({ showDeactivatePopup: false });
    }
    overlayFocusController() {
        if(this.state.showDeactivatePopup) {
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        } else {
            document.body.style.position = this.initialPositionValue;
            document.body.style.removeProperty("width");
        }
    }
    
    render(){
        this.overlayFocusController();
        const showPopup = this.state.showDeactivatePopup ? <DeactivateAccountPopup data={this.state} closeDeactivatePopupHandler={this.closeDeactivatePopupHandler.bind(this)} isMultiAccountView={this.state.isMultiAccountView} programEnrollmentDetails={this.state.programEnrollmentDetails} isWebUser={this.userType === this.userGroups.WEB} bpNumber={this.props.bpNumber} /> : null;
        const deActivateErrorJSX = this.state.showDeactivatePopupError ?  <div>
                                                                        <div className={classes.deActivatePopupErrSec}>
                                                                            <img className={classes.warnIcon} src={this.warningIcon} alt="Warning Icon" />
                                                                            <div className={classes.errorMsg}>{this.strings.deActivatePopupError}</div>
                                                                        </div>
                                                                     </div> : null;
        return(
            <div>
                {showPopup}
                <div className={classes.manageAccpadding}>
                    <div className={classes.manageAccLabel}>{this.strings.manageAccLabel}</div>
                    <div><p className={classes.manageAccInfo}>{this.strings.manageAccInfo}</p></div>
                    {deActivateErrorJSX}
                    <div className={classes.deleteIdLinkPadding}><a className={classes.sceSmLink} href="javascript:void(0)" onClick={this.openDeactivatePopupHandler} >{this.strings.deleteIdLink}</a></div>
                </div>
            </div>
        );
    }
}

export default ManageAccount;
